var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-telephone",on:{"click":function($event){_vm.$store.state.ui.sourcing.limit_detail_entreprise == 0 ? _vm.$store.dispatch('setCompany', _vm.entreprise) : null}}},[_vm._v(" "+_vm._s(_vm.entreprise.tel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }